import { format, parse } from "date-fns";
import { it } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Calendar as CalendarIcon } from "lucide-react";

export default function DatePickerField({ value, onChange, placeholder = "gg-mm-aaaa", testid, compact = false }) {
  const date = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          data-testid={testid}
          className={compact
            ? "h-7 w-full justify-start text-left font-normal font-sans bg-white text-[11px] rounded-none border-transparent px-1.5 hover:bg-blue-50/40"
            : "h-9 w-[150px] justify-start text-left font-normal bg-white text-sm"}
        >
          <CalendarIcon className={compact ? "h-3 w-3 mr-1 text-slate-400 flex-shrink-0" : "h-4 w-4 mr-2 text-slate-400"} />
          {date ? (
            format(date, "dd-MM-yyyy", { locale: it })
          ) : (
            <span className="text-slate-400">{placeholder}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          locale={it}
          onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
